import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MarkdownViewerComponent } from '@examdojo/ui/markdown-viewer';
import { ChatImagesListItemComponent } from '../../../base/components/chat-images-list-item/chat-images-list-item.component';
import { ImageChatMessageUIModel } from '../../models';

@Component({
  selector: 'dojo-image-chat-user-message',
  standalone: true,
  host: { class: 'flex justify-end' },
  template: `
    <div class="flex max-w-[80%] flex-col items-end">
      @if (message().message.images.length) {
        <div class="flex justify-end gap-2 p-2">
          @for (image of message().message.images; track $index) {
            <dojo-chat-images-list-item [base64String]="image" [class]="'h-18 w-18'" [editable]="false" />
          }
        </div>
      }
      <dojo-markdown-viewer
        [content]="message().message.text"
        class="text-primary rounded-[12px] bg-neutral-100 p-3 text-sm font-normal"
      />
    </div>
  `,
  imports: [MarkdownViewerComponent, ChatImagesListItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageChatUserMessageComponent {
  readonly message = input.required<ImageChatMessageUIModel>();
}
